/* brick-reveal.js — arm-then-reveal, mirroring Elementor's elementor-invisible -> animated swap.
   The armed class is added HERE, not in CSS, so a blocked or failed script can never leave the
   page invisible. */
(function () {
  var nodes = document.querySelectorAll('[data-brick-reveal]');
  if (!nodes.length) return;
  if (!('IntersectionObserver' in window)) return;   // no observer: content simply stays visible
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  // R7b DB7 (2026-10-02): an element already ON SCREEN when this runs is never hidden. Arming it set opacity:0 on the hero
  // text — the home page's Largest Contentful Paint element — until this deferred script ran, the observer fired and a 0.75 s
  // animation finished (mobile LCP 4.8 s, all of it "render delay"). Below-the-fold content keeps its entrance animation
  // (Dave 2026-09-14, Woo parity); above-the-fold content simply paints.
  var vh = window.innerHeight || document.documentElement.clientHeight;
  nodes = Array.prototype.filter.call(nodes, function (n) { return n.getBoundingClientRect().top >= vh; });
  if (!nodes.length) return;
  nodes.forEach(function (n) { n.classList.add('brick-reveal-armed'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('brick-revealed');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  nodes.forEach(function (n) { io.observe(n); });
})();
